import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// CRA only exposes env vars prefixed REACT_APP_ to the browser. The non-prefixed
// names read undefined at runtime — email/password auth works on apiKey +
// authDomain alone, but anything else (storage, messaging) would silently break.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
